import { render, staticRenderFns } from "./widgetPromoCode.vue?vue&type=template&id=6ca05eef&"
import script from "./widgetPromoCode.vue?vue&type=script&lang=js&"
export * from "./widgetPromoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports